import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { QimaTranslationFactory } from '@qima/ngx-qima';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class QimaTranslationFactoryService extends QimaTranslationFactory {
  public readonly activeLanguageSubject$ = new BehaviorSubject<string>('en');

  constructor(private translateService: TranslateService) {
    super();
    this.activeLanguageSubject$.next(this.translateService.currentLang || 'en');

    // Watch for language changes
    this.translateService.onLangChange.subscribe(change => {
      this.activeLanguageSubject$.next(change.lang);
    });
  }

  public translate$(translationKey: string, extra?: Readonly<Record<string, unknown>>): Observable<string> {
    // Note the prefix to match the JSON paths
    return this.translateService.get(`ngx-qima.${translationKey}`, extra) as Observable<string>;
  }
}
